import tokens from '@kluein/design-tokens';
import { Box, Layer, ThemeContext } from '@kluein/klue-ui';

import TEST_IDS from 'test-ids';

import { LAYER_Z_INDEX } from '../NavBarGlobalSearch';

import type { ReactElement, RefObject } from 'react';
import type { SuggestionType } from 'store/models/search-suggestions/searchSuggestions.model';

export type suggestionItems = {
  label: ReactElement;
  value: SuggestionType;
};

type UnifiedSearchSuggestionsProps = {
  inputRef: RefObject<HTMLInputElement>;
  onSuggestionsClose: (e?: any) => void;
  suggestionItems: suggestionItems[];
  searchContainerWidth?: number;
};

const UnifiedSearchSuggestions = ({
  inputRef,
  onSuggestionsClose,
  suggestionItems,
  searchContainerWidth,
}: UnifiedSearchSuggestionsProps) => {
  const shouldShowSuggestions = suggestionItems.length > 0;

  if (!shouldShowSuggestions) {
    return null;
  }

  return (
    <ThemeContext.Extend
      value={{ layer: { zIndex: (Number(LAYER_Z_INDEX) - 1).toString() } }}
    >
      <Layer
        modal={false}
        position="bottom"
        onClickOutside={onSuggestionsClose}
        onEsc={onSuggestionsClose}
        target={inputRef.current!}
        animation="fadeIn"
        background="transparent"
        style={{
          cursor: 'default',
        }}
        data-test-id={TEST_IDS.appNavBar.globalSearch.suggestions.container}
      >
        <Box
          pad={{ top: '8px' }}
          background={tokens.color.neutral.white.main}
          round="xsmall"
          elevation="small"
          flex={{ shrink: 0 }}
          style={{
            position: 'relative',
            top: 50,
            width: searchContainerWidth ? `${searchContainerWidth}px` : '100%',
          }}
        >
          <Box
            data-test-id={TEST_IDS.appNavBar.globalSearch.suggestions.list}
            height={{ max: 'large' }}
            overflow={{ vertical: 'auto' }}
          >
            {suggestionItems.map((suggestion) => suggestion.label)}
          </Box>
        </Box>
      </Layer>
    </ThemeContext.Extend>
  );
};

export default UnifiedSearchSuggestions;
